import{useState as e}from"react";import{useIsomorphicLayoutEffect as r}from"../useIsomorphicLayoutEffect/index.js";function u(){const[t,o]=e(!1);return r(()=>{o(!0)},[]),t}export{u as useIsMountedState};
//# sourceMappingURL=index.js.map
